import { render, staticRenderFns } from "./RefundPointsModal.vue?vue&type=template&id=62b3d1cf&scoped=true&"
import script from "./RefundPointsModal.vue?vue&type=script&lang=js&"
export * from "./RefundPointsModal.vue?vue&type=script&lang=js&"
import style0 from "./RefundPointsModal.vue?vue&type=style&index=0&id=62b3d1cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b3d1cf",
  null
  
)

export default component.exports